import clsx from 'clsx'
import {orderBy} from 'lodash'
import moment from 'helpers/moment'
import React, {useContext} from 'react'
import {makeStyles} from 'external/material'
import MuiTableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'

import {TeacherContext} from 'teacher/context'

const useStyles = makeStyles(studentGradesSummaryHeadStyles)

export default function StudentGradesSummaryHead() {

  const classes = useStyles()
  const context = useContext(TeacherContext)

  const {translate, groupId} = context

  const {items: periods} = context.rollbookContextPeriods
  const columns = orderBy(periods, [p => moment(p.start).valueOf()])

  return (
    <TableHead>
      <TableRow className={classes.headersRow}>
        <MuiTableCell className={classes.headerCell} style={{top:92}} align="left" />
        <TableCell
          id="global-summary-cell"
          align="center"
          classes={classes}
          cellClass={classes.summary}
          labelClass={classes.summaryLabel}
        >
          <span>{translate('student-grades-summary-global-header')}</span>
        </TableCell>
        {columns.map(column => {
          return (
            <TableCell
              key={column.id}
              id={`${column.label}-cell`}
              description={column.title}
              classes={classes}
              cellClass={classes.period}
              labelClass={classes.periodLabel}
              column={column}
            >
              <span className={classes.periodName}>{column.properties.name}</span>
            </TableCell>
          )
        })}
        <MuiTableCell className={classes.filler} style={{top:92}} align="right" />
      </TableRow>
    </TableHead>
  )
}

function TableCell (props) {

  const {
    id, label, align, disablePadding,
    column,
    classes, cellClass, labelClass, containerClass
  } = props

  return (<MuiTableCell
    align = {align || 'left'}
    padding={disablePadding ? 'none' : 'normal'}
    className={clsx(classes.headerCell, cellClass)}
    style={{top:92}}
  >
    <div className={classes.cellContainer}>
      <div className={clsx("label", containerClass)}>
        {props.children}
      </div>
    </div>
  </MuiTableCell>)
}

function studentGradesSummaryHeadStyles() {
    return {
        center: {
          textAlign: 'center'
        },
        headersRow: {
          color: '#50566e',
          '& > th': {
            borderTop: 'solid 1px #d8dbe0',
            backgroundColor: '#f1faff'
          }
        },
        headerCell: {
          padding: 0,
          width: 170,
          color: '#4f576e',
          fontWeight: 'bold',
          borderLeft: 'solid 1px #d8dbe0',
          borderRight: 'solid 1px #d8dbe0',
          '&:first-child': {
            borderLeft: 0
          },
          "& .label": {
            padding: '0 10px',
            textAlign: 'center'
          }
        },
    };
}
